import { Box, Center, Divider, Stack, Text } from "@chakra-ui/react";
import { InformacoesBasicas } from "./InformacoesBasicas";
import { InformacoesSaude } from "./InformacoesSaude";

interface FormAnimalProps {
  idAnimal?: string;
  onFilesSelected?: (files: File[]) => void;
}

export const FormAnimal = ({ idAnimal, onFilesSelected }: FormAnimalProps) => {
  return (
    <Box
      mt={5}
      padding="2rem 2rem 5rem 2rem"
      gap={5}
      bgColor="white"
      borderRadius="md"
      boxShadow="sm"
    >
      <Text fontSize="xl" fontWeight="medium">
        Dados do Animal{" "}
      </Text>
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={5}
        alignItems="flex-start"
      >
        <InformacoesBasicas
          idAnimal={idAnimal}
          onFilesSelected={onFilesSelected}
        />
        <Divider display={{ base: "block", md: "none" }} />
        <Center height="40rem" display={{ base: "none", md: "flex" }}>
          <Divider orientation="vertical" />
        </Center>
        <InformacoesSaude />
      </Stack>
    </Box>
  );
};
